import { isString } from '@app/utils/string';

export type Environment = 'production' | 'development' | 'preview';

const getEnvironment = () => {
  const uncheckedEnvironemnt =
    typeof window === 'undefined' ? process.env.VERCEL_ENV : process.env.NEXT_PUBLIC_ENVIRONMENT;

  if (
    !(
      uncheckedEnvironemnt === 'development' ||
      uncheckedEnvironemnt === 'production' ||
      uncheckedEnvironemnt === 'preview'
    )
  ) {
    throw new Error('no environment found');
  } else {
    const environment: Environment = uncheckedEnvironemnt;
    return environment;
  }
};

const getServerBaseUrl = () => {
  const vercelUrl = process.env.VERCEL_URL;
  const environment = getEnvironment();
  if (environment === 'development' || !isString(vercelUrl) || vercelUrl.length < 1) {
    return 'http://localhost:3000';
  }
  return environment === 'production'
    ? 'https://dashboard.astro.tax'
    : 'https://dashboard-develop.astro.tax';
};

export const getBaseUrl = () => {
  let baseUrl = '';
  if (runtimeEnvironment === 'browser') {
    baseUrl = `${window.location.protocol}//${window.location.host}`;
  } else {
    baseUrl = getServerBaseUrl();
  }
  return baseUrl;
};

export const runtimeEnvironment =
  typeof window !== 'undefined'
    ? 'browser'
    : // This will produce warnings during static code analysis (next build), but it should be fine
      typeof process !== 'undefined' && process.versions != null && process.versions.node != null
      ? 'node'
      : 'edge';

export default getEnvironment;
